import { Role } from '@/model/role';
import type { RouteRecordRaw } from 'vue-router';
import { MY_ACCOUNT_SECTIONS } from '@/model/my-account-section';
const MyAccount = () => import('@/components/my-account/MyAccount.vue');
const MyAccountView = () => import('@/components/my-account/MyAccountView.vue');
const MyAccountEdit = () => import('@/components/my-account/MyAccountEdit.vue');
const MyAccountEmployeeIntegrations = () =>
  import('@/components/my-account/MyAccountEmployeeIntegrations.vue');
const MyAccountEmployeeEdit = () =>
  import('@/components/my-account/MyAccountEmployeeEdit.vue');
const MyAccountEmployeeSettings = () =>
  import('@/components/my-account/MyAccountEmployeeSettings.vue');

const myAccountRoutes: RouteRecordRaw[] = [
  {
    path: '/my-account',
    component: MyAccount,
    meta: {
      role: Role.CUSTOMER,
      customer: true,
    },
    children: MY_ACCOUNT_SECTIONS.map(({ path, routeName }) => ({
      path,
      name: routeName,
      component: MyAccountView,
    })),
  },
  {
    path: '/my-account/edit',
    name: 'MyAccountEdit',
    component: MyAccountEdit,
    meta: {
      role: Role.CUSTOMER,
      customer: true,
    },
  },
  {
    path: '/my-account-employee',
    name: 'MyAccountEmployee',
    component: MyAccount,
    meta: {
      role: Role.STAFF,
    },
    children: [
      {
        path: 'edit',
        name: 'MyAccountEmployeeEdit',
        component: MyAccountEmployeeEdit,
        meta: {
          role: Role.STAFF,
        },
      },
      {
        path: 'settings',
        name: 'MyAccountEmployeeSettings',
        component: MyAccountEmployeeSettings,
        meta: {
          role: Role.STAFF,
        },
      },
      {
        path: 'integrations',
        name: 'MyAccountEmployeeIntegrations',
        component: MyAccountEmployeeIntegrations,
        meta: {
          role: Role.STAFF,
        },
      },
    ],
  },
];

export default myAccountRoutes;
